import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';

function useGtmLinkTracking() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!(e.target instanceof HTMLElement)) {
        return;
      }

      // Skip if click originated from a button (button tracking handles that)
      if (e.target.closest('button, [role="button"], input[type="button"], input[type="submit"]')) {
        return;
      }

      const link = e.target.closest('a');
      if (link instanceof HTMLAnchorElement) {
        triggerGoogleTagManagerCustomEvent(GtmEvents.LINK_CLICK, {
          text: link.textContent?.trim() || undefined,
          destination: link.href || undefined,
        });
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);
}

export default useGtmLinkTracking;
